import React from "react";
import "./Footer.css";
import { Button, Container } from "react-bootstrap";
import {
  FaLinkedinIn,
  FaInstagram,
  FaFacebookF,
  FaEnvelope,
  FaSkype,
  FaWhatsapp,
} from "react-icons/fa";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import logo from "../../Asset/codiffi-logo.svg";
import { IoMdCall } from "react-icons/io";
import india from "../../Asset/india.svg";
import { useNavigate } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";
import teamsLogo from "../../Asset/teams_logo.svg";
import { BsMicrosoftTeams } from "react-icons/bs";

const Footer = () => {
  const Link = ({ id, children, title }) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
      <span>{children}</span>
    </OverlayTrigger>
  );

  const navigate = useNavigate();

  const navigateTo = (path) => () => navigate(path);

  const domainName = window.location.hostname;
  const currentYear = new Date().getFullYear();

  return (
    <>
      <section className="footer">
        <Container>
          <div className="inner-footer-block">
            <div className="footer-row">
              <div className="column-1">
                <div className="footer-logo-block">
                  <p>
                    <img src={logo} alt="footerLogo"></img>
                  </p>
                  <div className="short-info">
                    <span>
                      We the Codeffian deliver enduring trust to the clients in
                      order to maintain transparency and ensure better results.
                    </span>
                  </div>
                </div>
              </div>
              <div className="column-2">
                <h4>Business Enquiries</h4>
                <ul>
                  <li>
                    <span>
                      <IoMdCall className="column-icon" />
                    </span>
                    <a href="tel:+919726012626" className="hover-line">
                      +91 97260-12626{" "}
                    </a>
                  </li>
                  <li>
                    <span>
                      <FaEnvelope className="column-icon" />
                    </span>
                    <a
                      href="mailto:codeffitech@gmail.com"
                      className="hover-line"
                    >
                      codeffitech@gmail.com{" "}
                    </a>
                  </li>
                  <li>
                    <span>
                      <img
                        src={teamsLogo}
                        alt="teams"
                        className="column-icon "
                      />
                    </span>
                    <a
                      href="https://teams.microsoft.com/l/chat/0/0?users=codeffitech@gmail.com"
                      target="_blank"
                      rel="noreferrer"
                      className="hover-line"
                    >
                      Codeffi
                    </a>
                  </li>
                </ul>
              </div>
              <div className="column-2 column-2-space">
                <h4>Career Enquiries</h4>
                <ul>
                  <li>
                    <span>
                      <IoMdCall className="column-icon" />
                    </span>
                    <a href="tel:+919998440241" className="hover-line">
                      +91 99984-40241{" "}
                    </a>

                  </li>
                  <li>
                    <span>
                      <FaEnvelope className="column-icon" />
                    </span>
                    <a
                      href="mailto:codeffitech@gmail.com"
                      className="hover-line"
                    >
                      info@codeffi.com
                    </a>
                  </li>
                  <li>
                    <span>
                      <FaWhatsapp className="column-icon" />
                    </span>
                    <a
                      href="whatsapp://send?phone=919726012626"
                      className="hover-line"
                    >
                      +91 97260-12626
                    </a>
                  </li>
                </ul>
              </div>
              <div className="column-3">
                <div className="inner-column-4">
                  <h4>Interested in discussing about your Project?</h4>
                  <Button
                    className="btn btn-primary"
                    onClick={navigateTo("/ContactUs")}
                  >
                    Book Appointment
                  </Button>
                </div>
              </div>
            </div>
            <div className="footer-line footer-line-center" />
            <div className="inner-footer-links">
              <div className="col-md-6 col-lg-4">
                <div className="menu-company-container">
                  <div className="row gutters-5">
                    <div className="col-6 col-sm-6 widget widget_nav_menu">
                      <h2 className="widget-title">Company</h2>
                      <div className="menu-company-container">
                        <ul className="menu">
                          <li>
                            <a
                              href="https://www.snappass.in/"
                              target="_blank"
                              rel="noreferrer"
                              className="footer-external-link"
                            >
                              <p>Snappass</p>
                            </a>
                          </li>
                          <li onClick={navigateTo("/CompanyOverview")}>
                            <p>About us</p>
                          </li>
                          <li onClick={navigateTo("/Services/Iot")}>
                            <p>Our Values</p>
                          </li>
                          <li onClick={navigateTo("/howweWork")}>
                            <p>How we work</p>
                          </li>
                          <li onClick={navigateTo("/portfolio")}>
                            <p>Portfolio</p>
                          </li>
                          <li onClick={navigateTo("/indus")}>
                            <p>Industries</p>
                          </li>
                          <li onClick={navigateTo("/lifeAtWeb")}>
                            <p>Life @ Codeffi</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-6 col-sm-6 widget widget_nav_menu">
                      <h2 className="widget-title">Services</h2>
                      <div className="menu-company-container">
                        <ul className="menu">
                          <li onClick={navigateTo("/Services/mobileApp")}>
                            <p>Mobile Apps</p>
                          </li>
                          <li onClick={navigateTo("/Services/webDevelopment")}>
                            <p>Web Development</p>
                          </li>
                          <li onClick={navigateTo("/Services/Iot")}>
                            <p>IoT</p>
                          </li>
                          <li onClick={navigateTo("/ai")}>
                            <p>Artificial Intelligence</p>
                          </li>
                          <li onClick={navigateTo("/Services/uiUx")}>
                            <p>UI/UX Design</p>
                          </li>
                          <li
                            onClick={navigateTo(
                              "/Services/dedicatedDevelopers"
                            )}
                          >
                            <p>Hire Dedicated Developers</p>
                          </li>
                          <li onClick={navigateTo("/Services/indusAutomation")}>
                            <p>Industrial Automation</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="menu-company-container">
                  <div className="row gutters-5">
                    <div className="col-6 col-sm-6 widget widget_nav_menu">
                      <h2 className="widget-title">Industries</h2>
                      <div className="menu-company-container">
                        <ul className="menu">
                          <li onClick={navigateTo("/indus/d2c")}>
                            <p>D2C</p>
                          </li>
                          <li onClick={navigateTo("/indus/fintech")}>
                            <p>Fintech</p>
                          </li>
                          <li onClick={navigateTo("/indus/eCommerce")}>
                            <p>eCommerce (B2B & B2C)</p>
                          </li>
                          <li onClick={navigateTo("/indus/logistic")}>
                            <p>Logistics & Shipping</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-6 col-sm-6 widget widget_nav_menu">
                      <h2 className="widget-title">More Links</h2>
                      <div className="menu-company-container">
                        <ul className="menu">
                          <li onClick={navigateTo("/Blog")}>
                            <p>Blog</p>
                          </li>
                          <li onClick={navigateTo("/Services")}>
                            <p>Success Stories</p>
                          </li>
                          <li onClick={navigateTo("/term&conditions")}>
                            <p>Term & Conditions</p>
                          </li>
                          <li onClick={navigateTo("/privacypolicy")}>
                            <p>Privacy Policy</p>
                          </li>
                          <li onClick={navigateTo("/ai")}>
                            <p>AI Lab</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-4">
                <div className="address-row">
                  <div>
                    <h4>Visit Us At</h4>
                    <div className="org-address">
                      <div>
                        <img
                          src={india}
                          alt="cardn"
                          style={{ height: "20px" }}
                        />
                      </div>
                      <div>
                        <p className="place">Mota Varchha (Surat)</p>
                        <p className="place-address">
                          301 (TF), Angel Business Center 1 (ABC), Opp.
                          Govardhan Square, ABC circle, Surat, Gujarat 394101.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-line footer-line-bottom" />
          </div>
          <div className="copyright">
            <span>
              © {currentYear} {domainName}. All rights reserved.
            </span>
            <ul>
              <li>
                <a
                  href="https://www.linkedin.com/company/codeffi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Link title="LinkedIn" id="t-1">
                    <FaLinkedinIn className="foot-icon" />
                  </Link>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/codeffiinfotech/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Link title="Instagram" id="t-2">
                    <FaInstagram className="foot-icon" />
                  </Link>
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/codeffi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Link title="Facebook" id="t-3">
                    <FaFacebookF className="foot-icon" />
                  </Link>
                </a>
              </li>
              <li>
                <a
                  href="https://x.com/codiffi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Link title="Twitter" id="t-4">
                    <FaXTwitter className="foot-icon" />
                  </Link>
                </a>
              </li>
            </ul>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Footer;
